import { Component } from '@angular/core';
import { IgxGridComponent } from 'igniteui-angular';

@Component({
    selector: 'app-menuwheel',
    templateUrl: './menuwheel.component.html',
    styleUrls: ['./menuwheel.component.scss']
})

export class MenuWheelComponent {

    public grid: IgxGridComponent;


    openAdvancedFiltering() {
        
    }
}